import './branch.scss';
//react
import React, {useEffect} from 'react';
import { useQuery } from '@apollo/client';
import { useNavigate, useLocation } from 'react-router-dom';
//shared
import { MuiButton } from '../shared/components/button/button';
import { BRANCH } from '../shared/graphql/branch';
import { BUTTON_NEXT } from "./constants/button";
import { SkeletonBranches } from '../shared/components/skeleton-branches/skeleton-branches';
//material
import { Box, MenuItem, Grid, FormControl, InputLabel } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { sendPageView } from '../shared/services/analytics'

function Branch() {

    const location = useLocation();
    useEffect(() => {
        sendPageView(location.pathname + location.search, "Elegir Sede");
    }, [location]);

    const navigate = useNavigate();
        let [branch, setBranch] = React.useState('');

        const { data, loading, error } = useQuery(BRANCH);

        useEffect(() => {
            if (data && data.branchesProvider && data.branchesProvider.length > 0) {
                const newBranch = data.branchesProvider[0].id;
                setBranch(newBranch);
                navigate(`/branch/${newBranch}`);
            }
        }, [data, navigate]);

    if (loading) return <SkeletonBranches />;
    if (error) console.log(`Submission error! ${error.message}`);

    const handleChange = (event: SelectChangeEvent) => {
        setBranch(event.target.value);
    };

    const event = () => {
        navigate(`/branch/${branch}`);
    }

    /* if (data){
        branch = data.branchesProvider[0].id;
        navigate(`/branch/${branch}`);
    } */

    return (
        <Box className='container'>
            <Grid container justifyContent={'center'}>
                <Grid item xs={12}>
                    <div className='container-branch'>
                        <h1>Estás inscrito en varias sedes.</h1>
                        <h2>Elige la sede que deseas administrar</h2>
                        <p> Tu sede</p>
                    </div>
                    <Grid container justifyContent={'center'}>
                        <Grid item xs={12} sm={12} mx={12} md={6}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Selecciona una sede</InputLabel>
                                        <Select
                                            
                                            labelId="BranchId"
                                            id="branch"
                                            value={branch}
                                            label="Sede"
                                            onChange={handleChange}
                                        >
                                            {data?.branchesProvider?.map((branch: any) => (
                                                <MenuItem key={branch.id} value={branch.id} >
                                                    <span className='item-text'>{branch.name}</span>
                                                </MenuItem>
                                            ))}
                                        </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <div className='button'>
                        <MuiButton buttonData={BUTTON_NEXT[0]} buttonClick={() => event()}></MuiButton>
                        {/* Pendiente redirigir a la sede seleccionada */}
                    </div>
                </Grid>
            </Grid>
        </Box>
    );
}

export default Branch;